import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  StyledProgressItem,
  StyledSVGIcon,
  StyledPara,
  StyledBar,
  StyledArrowSVGIcon,
  StyledBackButton,
  StyledMobileContainer,
  BackSVGIcon,
  StyledHeadingFourth,
  ProgressBarMasterContainer,
  BackButtonWrapper,
  StyledButton
} from './ProgressBar.styles';
import { colors } from '../css';
import Adaptive from '../Adaptive';
import Text from '../BuildingBlocks/Text';
import Grid from '../Utility/Grid';

class ProgressBar extends Component {
  static propTypes = {
    /** Array of step names and onClick functions  */
    progressItems: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        onClick: PropTypes.func
      })
    ),
    /** Current step # */
    step: PropTypes.number,
    /** Text on back button on lg/xl */
    backButtonText: PropTypes.string,
    /** Hide the back button */
    hideBackButton: PropTypes.bool,
    /** onClick function to route user */
    onBackClick: PropTypes.func
  };

  static defaultProps = {
    progressItems: [],
    step: 1,
    backButtonText: 'Back',
    hideBackButton: false,
    onBackClick: () => {}
  };

  render() {
    const { progressItems, step, backButtonText, onBackClick, hideBackButton } = this.props;

    const itemWidth = 100 / progressItems.length;

    const barWidth = itemWidth * step;
    return (
      <ProgressBarMasterContainer>
        <Grid.Row>
          {!hideBackButton ? (
            <Grid.Col sm={1}>
              <div>
                <BackButtonWrapper>
                  <StyledBackButton type="button" onClick={onBackClick}>
                    <BackSVGIcon selectedIcon="searchArrow" iconColor={colors.colorBlue} />{' '}
                    <Text.CopyParagraph textTransform="uppercase" tagName="span" color="quaternary" weight="bold">
                      {backButtonText}
                    </Text.CopyParagraph>
                  </StyledBackButton>
                </BackButtonWrapper>
              </div>
            </Grid.Col>
          ) : (
            <Grid.Col sm={1} />
          )}
          <Grid.Col sm={10}>
            <StyledHeadingFourth />
            <StyledBar barWidth={barWidth} />

            <Adaptive
              sm={
                <StyledMobileContainer>
                  {!hideBackButton && (
                    <StyledBackButton type="button" onClick={onBackClick}>
                      <StyledArrowSVGIcon selectedIcon="searchArrow" iconColor={colors.colorBlue} />
                    </StyledBackButton>
                  )}
                  <StyledPara color="quaternary" weight="bold" align="center">
                    {progressItems[step - 1].label}
                    {` (${step}/${progressItems.length})`}
                  </StyledPara>
                </StyledMobileContainer>
              }
              lg={progressItems.map((item, index) => (
                <StyledProgressItem key={item.label} width={itemWidth} step={step}>
                  {index + 1 < step && <StyledSVGIcon selectedIcon="checkmark" iconColor={colors.colorGrey03} />}
                  {index + 1 > step && !item.onClick && (
                    <StyledSVGIcon selectedIcon="padlock" iconColor={colors.colorGrey03} />
                  )}
                  <StyledPara weight="bold" color={index + 1 === step ? 'quaternary' : 'tertiary'}>
                    <StyledButton type="button" onClick={item.onClick} disabled={index + 1 > step}>
                      {item.label}
                    </StyledButton>
                  </StyledPara>
                </StyledProgressItem>
              ))}
            />
          </Grid.Col>
          <Grid.Col sm={1} />
        </Grid.Row>
      </ProgressBarMasterContainer>
    );
  }
}

export default ProgressBar;
